/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@dofinity/biu-components';

import { defineCustomElements } from '@dofinity/biu-components/loader';

defineCustomElements();
export const BiuA = /*@__PURE__*/createReactComponent<JSX.BiuA, HTMLBiuAElement>('biu-a');
export const BiuButton = /*@__PURE__*/createReactComponent<JSX.BiuButton, HTMLBiuButtonElement>('biu-button');
export const BiuCalendar = /*@__PURE__*/createReactComponent<JSX.BiuCalendar, HTMLBiuCalendarElement>('biu-calendar');
export const BiuCheckbox = /*@__PURE__*/createReactComponent<JSX.BiuCheckbox, HTMLBiuCheckboxElement>('biu-checkbox');
export const BiuDateBar = /*@__PURE__*/createReactComponent<JSX.BiuDateBar, HTMLBiuDateBarElement>('biu-date-bar');
export const BiuDropdown = /*@__PURE__*/createReactComponent<JSX.BiuDropdown, HTMLBiuDropdownElement>('biu-dropdown');
export const BiuRoundedButton = /*@__PURE__*/createReactComponent<JSX.BiuRoundedButton, HTMLBiuRoundedButtonElement>('biu-rounded-button');
export const BiuSearchBar = /*@__PURE__*/createReactComponent<JSX.BiuSearchBar, HTMLBiuSearchBarElement>('biu-search-bar');
export const BiuSelect = /*@__PURE__*/createReactComponent<JSX.BiuSelect, HTMLBiuSelectElement>('biu-select');
